import { DataSender } from '../loaders'

/**
* EmbedTicketsModal
*/

class EmbedTicketsModal {
    constructor(target, eventId) {
        this.apiScript = '<script src="https://app.plentix.co/js/api/embed-tickets.js" type="text/javascript"></script>'
        this.embedHtml = '<div style="height: %HEIGHT%; width: %WIDTH%;"><iframe data-ey="true" data-event-id="%EVENTID%" data-key="%KEY%" data-layout="%LAYOUT%" data-label="%LABEL%" id="%ID%" style="visibility: hidden;"></iframe></div>'
        this.layouts = {
            INLINE: 'inline',
            BUTTON_SMALL: 'button-small',
            BUTTON_NORMAL: 'button-normal',
            BUTTON_BIG: 'button-big',
            array: function() {
                var a = []; for(var i in this) if(typeof this[i] == 'string') a.push(this[i]);
                return a;
            }
        };
        this.layoutProperties = {
            'inline': {
                frameHeight: '650px',
                frameWidth: '750px'
            },

            'button-small': {
                frameHeight: '30px',
                frameWidth: '120px'
            },

            'button-normal': {
                frameHeight: '50px',
                frameWidth: '180px'
            },

            'button-big': {
                frameHeight: '70px',
                frameWidth: '240px'
            }
        };


        if(!target || !target.length || !eventId) {
            window.activeModalInstance = null;
            return;
        }

        this.target = target;
        this.eventId = eventId;
        this.eventKey = null;
        this.texts = null;
        this.timeout = null;

        this.loadModal();
    }

    loadModal() {
        var that = this;

        this.target.html('<div class="activity-indicator gray"></div>');
        this.target.show();

        new DataSender({
            data: { id: this.eventId },
            url: '/event/tickets/embed-options/',

            success: function(data) {
                if(data.status) {
                    that.target.html(data.html);

                    that.eventKey = data.key;
                    that.texts = window.embedTicketsModalTexts;

                    that.initModal();
                }
            },

            error: function() {
                that.closeModal();
            }
        });
    }

    initModal() {
        var that = this;

        this.header = this.target.find('.modal-header');
        this.header.find('button').bind('click', function() {
            that.closeModal();
        });

        // BUTTON:
        this.buttonColumn = this.target.find('.button');

        this.buttonLayoutPreview = this.buttonColumn.find('div.layout');

        this.buttonSize = this.buttonColumn.find('select');
        this.buttonSize.bind('change', function() {
            that.buttonLayoutPreview.removeClass(that.layout.array().join(' '));
            that.buttonLayoutPreview.addClass(that.buttonSize.val());

            that.generateCode(that.buttonSize.val(), that.buttonLabel.val());
        });

        this.buttonLabel = this.buttonColumn.find('input');
        this.buttonLabel.bind('input', function() {
            that.generateCode(that.buttonSize.val(), that.buttonLabel.val());
        });

        this.buttonTextarea = this.buttonColumn.find('textarea');
        this.buttonTextarea.bind('click', function() {
            that.buttonTextarea.highlight('green', { hideEvent: 'blur', html: that.texts.pasteCode, placement: 'left' });
            that.buttonTextarea.select();
        });

        // INLINE:
        this.inlineColumn = this.target.find('.inline');

        this.inlineTextarea = this.inlineColumn.find('textarea');
        this.inlineTextarea.bind('click', function() {
            that.inlineTextarea.highlight('green', { hideEvent: 'blur', html: that.texts.pasteCode, placement: 'right' });
            that.inlineTextarea.select();
        });

        // INIT:
        this.generateCode(this.buttonSize.val(), this.buttonLabel.val(), false);
        this.generateCode(that.layouts.INLINE);
    }

    closeModal() {
        console.log(this.target)
        this.target.hide();
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();

        window.activeModalInstance = null;
    }

    generateCode(layout, label, highlight) {
        label = (label != undefined) ? label : null;
        highlight = (highlight != undefined) ? highlight : true;

        var that = this;
        var code = this.apiScript + this.embedHtml;
        var frameId = Math.random().toString(36).substr(2, 8);

        code = code.replace(/%HEIGHT%/, this.layoutProperties[layout].frameHeight)
                   .replace(/%WIDTH%/, this.layoutProperties[layout].frameWidth)
                   .replace(/%EVENTID%/, this.eventId)
                   .replace(/%KEY%/, this.eventKey)
                   .replace(/%LAYOUT%/, layout)
                   .replace(/%LABEL%/, $.trim(label))
                   .replace(/%ID%/, frameId);

        if(layout == that.layouts.INLINE) {
            this.inlineTextarea.text(code);
        }
        else {
            if(highlight) {
                this.buttonTextarea.addClass('highlighted');

                window.clearTimeout(this.timeout);
                this.timeout = window.setTimeout(function() {
                    that.buttonTextarea.removeClass('highlighted');
                }, 400);
            }

            this.buttonTextarea.text(code);
        }
    }
}

export { EmbedTicketsModal }
